import styled from 'styled-components';

import DateField from 'components/form/RecurringForm/components/DatesRangeSelector/DateField/container';

export default styled(DateField)`
  align-items: baseline;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: -1px 0;
  position: relative;
`;
